import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from '../../pages/Home';
import PageNotfound from '../../pages/PageNotfound';
import MyAccount from '../../pages/MyAccount';
import Education from '../../pages/resume-builder-pages/Education';
import Finalize from '../../pages/resume-builder-pages/Finalize';
import History from '../../pages/resume-builder-pages/History';
import Profile from '../../pages/resume-builder-pages/Profile';
import Skills from '../../pages/resume-builder-pages/Skills';
import Summary from '../../pages/resume-builder-pages/Summary';
import ThankYou from '../../pages/resume-builder-pages/ThankYou';
import PrivateRoute from './PrivateRoute';
import ResumeBuilder from '../../pages/resume-builder-pages/ResumeBuilder';
import ReviewResume from '../../pages/resume-builder-pages/ReviewResume';

function RouteList() {
    return (
        <>
            <Routes>
                <Route element={<PrivateRoute />}>


                    {/* Resume Page routing start  */}

                    <Route path="/my-account" element={<MyAccount />} />
                    <Route path="/resume-builder" element={<ResumeBuilder />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/experience" element={<History />} />
                    <Route path="/education" element={<Education />} />
                    <Route path="/skill" element={<Skills />} />
                    <Route path="/summary" element={<Summary />} />
                    <Route path="/finalize" element={<Finalize />} />
                    <Route path='/review-resume' element={<ReviewResume />} />
                    <Route path="/thank-you" element={<ThankYou />} />

                    {/* Resume Page routing end  */}

                </Route>

                <Route path="/home" element={<Home />} />
                <Route path="/" element={<Home />} />
                <Route path='*' element={<PageNotfound />} />

            </Routes>
        </>
    )
}

export default RouteList
